import { Status } from 'components';

import { productStore } from '../../store';

export const TitleExtraNode = () => {
  const status = productStore((state) => state.status);

  return <Status status={status} />;
};
